<div class="accounting-firm-search-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="accounting-firm-topic">
      <!-- desktop heading -->
      <div
        class="accounting-firm-topic__heading"
        [innerHtml]="
          accountingFirmDisplayType == 'recommend'
            ? ('NEW_ACCOUNTING_FIRM.FIND_SECTION.RECOMMEND.HEADING' | translate)
            : ('NEW_ACCOUNTING_FIRM.FIND_SECTION.ALL_ACCOUNTING_FIRM.HEADING' | translate)
        "
      ></div>
    </div>

    <div class="box-search">
      <div class="box-search__wrapper">
        <div class="box-search__wrapper--element" [ngClass]="{ 'dropdown-visible': isDropdownVisible }">
          <picture><img src="https://flowaccountcdn.com/new_landing/icon/search.svg" alt="" /></picture>
          <div *ngIf="searchProvinces.length > 0" class="element-tag">
            <span class="element-tag__text">{{ searchProvinces[0] }}</span>
            <button type="button" class="element-tag__clear" (click)="clearProvince(searchProvinces[0])">
              <img
                src="https://flowaccountcdn.com/new_landing/icon/close.svg"
                class="element-tag__clear--layout"
                alt="close"
              />
            </button>
          </div>
          <input
            type="text"
            [placeholder]="'NEW_ACCOUNTING_FIRM.FIND_SECTION.SEARCH_ACCOUNTING_FIRM' | translate"
            [(ngModel)]="searchName"
            name="searchName"
            (ngModelChange)="onSearch()"
            (click)="isDropdownVisible = false"
            class="element-input"
          />
          <button type="button" class="element-button" (click)="toggleDropdown()">
            <picture
              ><img
                src="https://flowaccountcdn.com/new_landing/icon/province.svg"
                class="button-default"
                alt="province" />
              <img
                src="https://flowaccountcdn.com/new_landing/icon/province_hover.svg"
                class="button-hover"
                alt="province"
            /></picture>
          </button>

          <div class="element-line"></div>

          <button type="button" class="element-button" (click)="clearSearch()">
            <picture
              ><img src="https://flowaccountcdn.com/new_landing/icon/cancel.svg" class="button-default" alt="cancel" />
              <img src="https://flowaccountcdn.com/new_landing/icon/cancel_hover.svg" class="button-hover" alt="cancel"
            /></picture>
          </button>
        </div>
        <div class="box-search__wrapper--dropdown" [ngClass]="{ show: isDropdownVisible }">
          <div class="dropdown-list">
            <div
              class="dropdown-list__item"
              *ngFor="let province of filteredProvinces"
              (click)="selectProvince(province)"
              [ngClass]="{ selected: searchProvinces.includes(province) }"
              ><span>{{ province }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!accountingfirmList || accountingfirmList.length === 0">
      <div class="box-noresults"
        ><img
          class="box-noresults__image"
          [src]="
            translate.currentLang === 'th'
              ? 'https://flowaccountcdn.com/new_landing/icon/no_result_found_th.png'
              : 'https://flowaccountcdn.com/new_landing/icon/no_result_found_en.png'
          "
          alt="no result found"
      /></div>
    </div>

    <div class="search-container">
      <div class="search-box" *ngIf="accountingFirmDisplayType == 'partner'">
        <select class="search-box__select" #typeFilter>
          <option *ngFor="let type of typeList[lang] | keyvalue" value="{{ type.key }}">{{ type.value }}</option>
        </select>

        <select class="search-box__select" #regionFilter>
          <option *ngFor="let type of regionList[lang] | keyvalue" value="{{ type.key }}">{{ type.value }}</option>
        </select>

        <div class="box">
          <div class="box__btn" (click)="searchAccountingFirm(typeFilter.value, regionFilter.value)">
            <a class="flowbtn app-btn box__btn--layout"> {{ 'NEW_ACCOUNTING_FIRM.SEARCH' | translate }}</a>
          </div>
        </div>
      </div>

      <div class="place-container">
        <ng-container *ngFor="let item of accountingfirmList">
          <div class="place-box" [ngClass]="{ 'custom-height': accountingFirmDisplayType == 'partner' }">
            <div class="place-box__image">
              <img
                src="{{
                  item.logo
                    ? item.logo
                    : 'https://flowaccountcdn.com/new_landing/image/accountingfirm/find-accountingfirm/back-logo.png'
                }}"
                [ngClass]="{ 'custom-P00008': item.id === 'P00008' }"
                alt="accounting-firm-place-logo"
                width="auto"
                height="60"
                loading="lazy"
              />
            </div>
            <div class="place-box__name">{{ displayText(item.name_th, item.name_en) }}</div>
            <div class="place-box__location">
              <i class="fas fa-map-marker-alt"></i> {{ displayText(item.province_th, item.province_en) }}
            </div>
            <div class="place-box__acccounting-firm"
              ><i class="fas fa-briefcase"></i
              ><span
                >{{ typeList[lang][item.type] }}
                <span *ngIf="item.nameUrl" class="nameUrl-right"
                  ><a
                    [routerLink]="['information/' + item.nameUrl]"
                    class="routerLink-color"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><span>{{
                      'NEW_ACCOUNTING_FIRM.RECOMMEND-PARTNER.INFORMATION.WEBSITE_LINK_PARTNER' | translate
                    }}</span></a
                  ></span
                >
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="pagination-section" id="accfirmBusinessownerRecommend">
      <pagination
        [totalItems]="totalItems"
        [(ngModel)]="currentPage"
        [itemsPerPage]="itemsPerPage"
        (pageChanged)="pageChanged($event)"
        [previousText]="'<'"
        [nextText]="'>'"
        [align]="true"
        class="pagination-tab"
        [maxSize]="maxSizePage"
      ></pagination>
    </div>
  </div>
</div>
